

import React from 'react'
import settings from '@settings'
import { useMediaQuery } from 'usehooks-ts';

const backgroundFont = settings.mq({
    backgroundColor: settings.colors.light,
    position: 'absolute',
    top: '50%',
    left: '50vw',
    width: '100vh',
    transform: 'rotate(-90deg) translate(-20%, -50%)',
    whiteSpace: 'nowrap',
    opacity: 0.1,
    color: settings.colors.grey,
    fontSize: [18, 24, '42vh'],
    zIndex: -1,
    fontWeight: 700,
})

const BackgroundFont = ({text}: {text: string}) => {
  const isTableOrMobile = useMediaQuery('(max-width: 768px)');
  
  if(isTableOrMobile) return null
  
  return (
    <div css={backgroundFont}>
        {text}
    </div>
  )
}

export default BackgroundFont;